import React from 'react'
import { Component } from 'react'


class KeineErgebnisse extends Component {

    render() {
        return (
            <div>
                <p className={"not-found"}>Für Ihre Suchanfrage wurden leider keine Einträge gefunden.</p>
            </div>
        );
    }
}

export default KeineErgebnisse;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/KeineErgebnisse.js